<!-- eslint-disable vue/no-setup-props-destructure -->
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Pagination} from "swiper";
import "swiper/css";
import "swiper/css/pagination";

export default {
  components: { Swiper, SwiperSlide },
  props: {
    info: {
      type: Array,
    },
  },
  setup() {
    return { modules: [Pagination, Autoplay] };
  },
};
</script>

<template>
  <div class="flex justify-center items-center w-full">
    <Swiper
      class="cursor-grab m-auto my-24 w-full md:w-3/4"
      :modules="modules"
      :space-between="20"
      :loop="true"
      :pagination="{ clickable: true }"
      :autoplay="{
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }"
    >
      <swiper-slide
        v-for="image in info"
        :key="image"
        class="pb-20 md:pb-14 flex justify-center items-center"
      >
        <div
          class="w-[85%] md:w-[600px] h-[500px] md:h-[750px] flex justify-center items-center overflow-y-scroll scrollbar-hide rounded-3xl scrollable"
        >
          <img :src="image" alt="image" class="w-[100%] h-fit rounded-3xl" />
        </div>
      </swiper-slide>
    </Swiper>
  </div>
</template>


<style>

</style>



